import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LayoutComponent } from './layout/layout/layout.component';
import { SupportModule } from './support/support.module';
import { UserModule } from './user/user.module';
import { UpdatesModule } from './updates/updates.module';
import { ReportsModule } from './reports/reports.module';
import { AssetManagementModule } from './assetmanagement/assetmanagement.module';
import { ActivityModule } from './activity/activity.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BreadcrumbComponent } from './shared/components/breadcrumb/breadcrumb.component';
import { ErrorComponent } from './shared/components/error/error.component';
import { BannerComponent } from './shared/components/banner/banner.component';
import { CallbackComponent } from './callback.component';
import { NotAssignedComponent } from './notassigned/not-assigned.component';

import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { NotFoundComponent } from './shared/404/notfound.component';
import { WorldWatchService } from './shared/services/worldwatch.service';
import { UserPreferenceService } from './shared/services/userpreferences.service';
import { VulnerabilitiesService } from './shared/services/vulnerabilities.service';
import { OktaInterceptor } from './shared/interceptors/oktaInterceptor';
import { ErrorService } from './shared/services/error.service';
import { ActivityService } from './shared/services/activity.service';
import { AppSharedModule } from './app-shared.module';
import { ItsmService } from './shared/services/itsm.service';
import { ItsmGenerator } from './shared/mock/itsm.generator';
import { AngularFileUploaderModule } from "angular-file-uploader";
import { HighchartsChartModule } from 'highcharts-angular';

import { RssService } from './shared/services/rss.service';
import { OktaUserService } from './shared/services/oktauser.service';
import { TenantComponent } from './tenant/tenant.component';
import { FormsModule } from '@angular/forms';
import { FileAccessService } from './shared/services/fileaccess.service';
import { DashboardLayoutComponent } from './layout/dashboardlayout/dashboardlayout.component';
import { NoMenuLayoutComponent } from './layout/nomenulayout/nomenulayout.component';
import { TermsOfUseComponent } from './shared/components/policies/terms-of-use/terms-of-use.component';
import { PrivacyPolicyComponent } from './shared/components/policies/privacy-policy/privacy-policy.component';
import { CookiePolicyComponent } from './shared/components/policies/cookie-policy/cookie-policy.component';
import { RetentionService } from './shared/services/retention.service';


@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    LayoutComponent,
    DashboardLayoutComponent,
    NoMenuLayoutComponent,
    BreadcrumbComponent,
    ErrorComponent,
    BannerComponent,
    CallbackComponent,
    NotFoundComponent,
    TenantComponent,
    NotAssignedComponent,
    TermsOfUseComponent,
    PrivacyPolicyComponent,
    CookiePolicyComponent
  ],
  imports: [
    AppSharedModule,
    BrowserModule,
    SupportModule,
    UserModule,
    UpdatesModule,
    ReportsModule,
    AssetManagementModule,
    ActivityModule,
    AppRoutingModule,
    HttpClientModule,
    FontAwesomeModule,
    AngularFileUploaderModule,
    FormsModule,
    NgbModule,
    HighchartsChartModule
  ],
  providers: [
    RetentionService,
    WorldWatchService,
    UserPreferenceService,
    VulnerabilitiesService,
    ErrorService,
    ItsmService,
    RssService,
    ItsmGenerator,
    ActivityService,
    OktaUserService,
    FileAccessService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: OktaInterceptor,
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(library: FaIconLibrary){
    library.addIconPacks(fas);
  }

 }
